import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { isDraftAssistantFrontierEnabled } from './isDraftAssistantFrontierEnabled';
import { isAIX00User } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';
import hasM365CopilotLicense from './hasM365CopilotLicense';

export function isDraftAssistantEnabled(mailboxInfo: MailboxInfo): boolean {
    // for AIX00 users, we want to scope them specifically as they are special group of users
    // who help with early feedback.
    return (
        (isAccountFeatureEnabled('mon-copilot-draft-assistant', mailboxInfo) &&
            hasM365CopilotLicense(mailboxInfo)) ||
        isDraftAssistantFrontierEnabled(mailboxInfo) ||
        (isAIX00User(mailboxInfo) &&
            getApplicationSettings('CopilotAIX00', mailboxInfo).draftAssistantEnabled)
    );
}
